import React, { useEffect, useState } from "react";
import "./PackageDetails.css";
import ButtonToDownloadTablePDF from "./ButtonToDownload";
import logo from "../../assets/images/Mountain-mystries-logo.png";
import { formatDateToYYYYMMDD, formatIndianCurrency, textDateFormatter } from "../../utils/utils";
import { getDecryptedData } from "../../utils/crypto";
import "../../Pages/PkgItinerary/PkgItinerary.css";
import { pdf, PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import NewPackageDownloadPdf from "./NewPackageDownloadPdf";
import { SvgDownload } from "../../utils/svgIcons";
import { showErrorToast } from "../../assets/toastUtils";
import { saveAs } from "file-saver";
import NewGetQuoteDownloadPopup from "../NewGetQuoteDownloadPopup/NewGetQuoteDownloadPopup";

const NewDownloadPdfButton = ({
    packageData,
    // setOpenGetQuotePopup,
    selectedCategory,
    allPackageHotels,
    selectedMealPlan,
}) => {
    const [markupData, setMarkupData] = useState(null);
    const [markupValue, setMarkupValue] = useState(0);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [openGetQuotePopup, setOpenGetQuotePopup] = useState(false);
    const [selectedOption, setSelectedOption] = useState("newMarkup");

    const fetchMarkup = async () => {
        const myHeaders = new Headers();
        myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
        myHeaders.append("Cookie", `${process.env.REACT_APP_COOKIE}`);

        const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow",
        };

        fetch(
            `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/markups`,
            requestOptions
        )
            .then((response) => response.json())
            .then((result) => {
                if (result.success) {
                    const findObject = result?.data?.find(
                        (mark) => mark?.markupCustomer === "both"
                    );
                    // console.log("findObject", findObject);

                    if (findObject) {
                        setMarkupData(findObject);
                    } else {
                        setMarkupData(null);
                    }
                } else {
                    setMarkupData("No data found");
                }
            })
            .catch((error) => console.error(error));
    };

    useEffect(() => {
        fetchMarkup();
    }, []);

    const calculatePriceWithMarkup = (
        basePrice
        // additionalMarkup = 0,
        // additionalMarkupType = "percentage"
    ) => {
        if (!markupData) return basePrice;

        let additionalMarkupType = "percentage";
        let additionalMarkup = markupValue;

        const { markupType, amount } = markupData;
        let finalPrice = basePrice;

        if (markupType === "percentage") {
            const percentageAmount = (parseFloat(amount) / 100) * basePrice;
            finalPrice += percentageAmount;
        } else if (markupType === "fixed") {
            finalPrice += parseFloat(amount);
        }

        if (
            !additionalMarkup ||
            additionalMarkup === "" ||
            additionalMarkup === "0" ||
            additionalMarkup === "0.0" ||
            additionalMarkup === 0 ||
            additionalMarkup === null ||
            additionalMarkup === undefined
        ) {
            return finalPrice;
        }

        // Apply additional markup
        if (additionalMarkupType === "percentage") {
            const additionalPercentageAmount =
                (parseFloat(additionalMarkup) / 100) * finalPrice;
            finalPrice += additionalPercentageAmount;
        } else if (additionalMarkupType === "fixed") {
            finalPrice += parseFloat(additionalMarkup);
        }

        return finalPrice;
    };

    // const finalPrice = calculatePriceWithMarkup(price);

    const userType = localStorage.getItem("userType");
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));

    const token = getDecryptedData("userToken");
    const [imageData, setImageData] = useState(null);

    const agent_selected_id = JSON.parse(localStorage.getItem("userDetails"));
    // const [selectedOption, setSelectedOption] = useState("selectedHotels");

    const [baseImages, setBaseImages] = useState([]);

    const [encodedUrl, setEncodedUrl] = useState("");

    async function imageUrlToBase64Canvas(url) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = "Anonymous"; // This is important to handle CORS
            img.src = url;

            img.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                const dataURL = canvas.toDataURL("image/png"); // Convert to base64
                resolve(dataURL);
            };

            img.onerror = (error) => {
                reject(new Error("Error loading image: " + error));
            };
        });
    }

    const encodeImageToBase64 = async (imageUrl) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = "Anonymous"; // Enable CORS
            img.src = imageUrl;

            img.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;

                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, img.width, img.height);

                const dataURL = canvas.toDataURL("image/jpeg");
                resolve(dataURL);
            };

            img.onerror = (err) => reject(err);
        });
    };

    const packageHotels = packageData?.packageItinerary?.flatMap(
        (item) => item.accommodation
    );

    const groupByCategory = (accommodations) => {
        return (
            accommodations &&
            accommodations?.reduce((acc, accommodation) => {
                const category = accommodation.hotelcategory;
                if (!acc[category]) {
                    acc[category] = [];
                }
                acc[category].push(accommodation);
                return acc;
            }, {})
        );
    };

    const fetchMedia = async (agentToken) => {
        const myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", `Bearer ${agentToken}`);
        myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

        const formdata = new FormData();
        formdata.append("modelType", "agents");
        formdata.append("modelId", agent_selected_id?.id);
        formdata.append("upload_collection", "agent-logo");

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow",
        };

        try {
            const response = await fetch(
                `${process.env.REACT_APP_BASE_URL}/api/v1/website/agent/file/fetch`,
                requestOptions
            );
            const result = await response.json();
            if (result.success) {
                setImageData(result?.data);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (token && userType === "agent") {
            setIsLoggedIn(true);
            fetchMedia(token);
        } else {
            setIsLoggedIn(false);
        }
    }, [token]);

    const handleSelectedOptionChange = (option) => {
        setSelectedOption(option);
    };

    const groupHotelsByCategory = (hotels) => {
        return hotels.reduce((acc, hotel) => {
            if (!acc[hotel.hotelcategory]) {
                acc[hotel.hotelcategory] = [];
            }
            acc[hotel.hotelcategory].push(hotel);
            return acc;
        }, {});
    };

    const groupedHotels = groupHotelsByCategory(allPackageHotels);

    const handleDownloadHandler = () => {
        setShowPopup(false);
        setOpenGetQuotePopup(true);
    };

    const handleOptionChange = (option) => {
        setSelectedOption(option);
        // onSelectedOptionChange(option);
    };

    const fetchImageAsBase64 = async (imageUrl) => {
        if (!imageUrl || typeof imageUrl !== "string") {
            console.error("fetchImageAsBase64: Invalid image URL:", imageUrl);
            return null;
        }

        try {
            const response = await fetch(imageUrl, {
                mode: "cors",
                cache: "no-store",
            });

            if (!response.ok) {
                console.error(
                    "fetchImageAsBase64: Failed to fetch image",
                    response.statusText
                );
                return null;
            }

            const blob = await response.blob();

            return await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = () => reject("FileReader failed");
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error("fetchImageAsBase64: Error occurred", error);
            return null;
        }
    };

    const [isDownloading, setIsDownloading] = useState(false);

    // const handleDownload = async () => {
    //     setShowPopup(false);
    //     setIsDownloading(true);
    //     const logoBase64 = await fetchImageAsBase64(imageData || "");

    //     const destinationImages = await Promise.all(
    //         packageData?.packageDestination?.map(dest => 
    //             fetchImageAsBase64(dest?.image)
    //         ) || []
    //     );

    //     const hotelsWithImages = await Promise.all(
    //         allPackageHotels?.map(async (hotel) => {
    //             const featuredImageBase64 = await fetchImageAsBase64(hotel?.featuredImage);
    //             return {
    //                 ...hotel,
    //                 base64FeaturedImage: featuredImageBase64 || hotel?.featuredImage
    //             };
    //         }) || []
    //     );

    //     const doc = (
    //         // <PackagePDF
    //         //     pkgDetail={pkgDetail}
    //         //     imageData={imageData}
    //         //     logo={logo}
    //         //     userDetails={userDetails}
    //         //     userType={userType}
    //         //     selectedCategory={selectedCategory}
    //         //     allPackageHotels={allPackageHotels}
    //         //     calculatePriceWithMarkup={calculatePriceWithMarkup}
    //         //     selectedOption={selectedOption}
    //         //     additionalMarkup={markupValue}
    //         //     selectedMealPlan={selectedMealPlan}
    //         // />

    //         <NewPackageDownloadPdf
    //             // packageData={packageData}
    //             packageData={{
    //                 ...packageData,
    //                 packageDestination: packageData?.packageDestination?.map((dest, index) => ({
    //                     ...dest,
    //                     base64Image: destinationImages[index]
    //                 }))
    //             }}
    //             imageData={logoBase64}
    //             logo={logo}
    //             userDetails={userDetails}
    //             userType={userType}
    //             selectedCategory={selectedCategory}
    //             // allPackageHotels={allPackageHotels}
    //             allPackageHotels={hotelsWithImages}
    //             calculatePriceWithMarkup={calculatePriceWithMarkup}
    //             selectedOption={selectedOption}
    //             additionalMarkup={markupValue}
    //             selectedMealPlan={selectedMealPlan}
    //         />
    //     );

    //     const blob = await pdf(doc).toBlob(); 
    //     const fileName = `${packageData?.packageName || "package"
    //         }-details-${formatDateToYYYYMMDD(new Date())}-${new Date()
    //             .toLocaleTimeString("en-GB")
    //             .replace(/:/g, "-")}.pdf`;

    //     saveAs(blob, fileName); // Save the file
    //         }
    // };

    const handleDownload = async () => {
        setShowPopup(false);
        setIsDownloading(true); // Start loading

        try {
            const logoBase64 = await fetchImageAsBase64(imageData || "");

            const [destinationImages, hotelsWithImages] = await Promise.all([
                Promise.all(
                    packageData?.packageDestination?.map(dest =>
                        fetchImageAsBase64(dest?.image)
                    ) || []
                ),
                Promise.all(
                    allPackageHotels?.map(async (hotel) => {
                        const featuredImageBase64 = await fetchImageAsBase64(hotel?.featuredImage);
                        return {
                            ...hotel,
                            base64FeaturedImage: featuredImageBase64 || hotel?.featuredImage
                        };
                    }) || []
                )
            ]);

            const doc = (
                <NewPackageDownloadPdf
                    packageData={{
                        ...packageData,
                        packageDestination: packageData?.packageDestination?.map((dest, index) => ({
                            ...dest,
                            base64Image: destinationImages[index]
                        }))
                    }}
                    imageData={logoBase64}
                    logo={logo}
                    userDetails={userDetails}
                    userType={userType}
                    selectedCategory={selectedCategory}
                    allPackageHotels={hotelsWithImages}
                    calculatePriceWithMarkup={calculatePriceWithMarkup}
                    selectedOption={selectedOption}
                    additionalMarkup={markupValue}
                    selectedMealPlan={selectedMealPlan}
                />
            );

            const blob = await pdf(doc).toBlob();
            const fileName = `${packageData?.packageName || "package"}-details-${formatDateToYYYYMMDD(new Date())}-${new Date()
                .toLocaleTimeString("en-GB")
                .replace(/:/g, "-")}.pdf`;

            saveAs(blob, fileName);
        } catch (error) {
            console.error("Error generating PDF:", error);
            // Optionally show error to user
            alert("Failed to generate PDF. Please try again.");
        } finally {
            setIsDownloading(false); // Stop loading regardless of success/failure
        }
    };

    return (
        <>
            <div>
                {/* <ButtonToDownloadTablePDF
        itemToDownloadID={"package-details"}
        setOpenGetQuotePopup={setOpenGetQuotePopup}
        packageData={pkgDetail}
        onSelectedOptionChange={handleSelectedOptionChange} // Pass function to child
        longPdf={true}
        imageData={imageData}
        pkgDetail={pkgDetail}
        userDetails={userDetails}
        userType={userType}
        logo={logo}
        selectedCategory={selectedCategory}
        allPackageHotels={allPackageHotels}
        calculatePriceWithMarkup={calculatePriceWithMarkup}
        selectedOption={selectedOption}
        markupValue={markupValue}
        setMarkupValue={setMarkupValue}
        selectedMealPlan={selectedMealPlan}
      /> */}

                {/* <PDFDownloadLink
                document={<NewPackageDownloadPdf packageData={packageData} />}
                fileName={`${packageData?.name || "package"
                    }-${formatDateToYYYYMMDD(new Date())}-${new Date()
                        .toLocaleTimeString("en-GB")
                        .replace(/:/g, "-")}.pdf`}
            >
                {({ blob, url, loading, error }) => (loading ? "..." :
                    <svg
                        width="19"
                        height="18"
                        viewBox="0 0 19 18"
                        fill='#000000'
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <mask
                            id="mask0_6005_5339"
                            style={{ maskType: "alpha" }}
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="19"
                            height="18"
                        >
                            <rect x="0.5" width="18" height="18" fill="#000000" />
                        </mask>
                        <g mask="url(#mask0_6005_5339)">
                            <path
                                d="M9.5 11.5586C9.40963 11.5586 9.3255 11.5442 9.24763 11.5153C9.16975 11.4866 9.09569 11.4371 9.02544 11.3668L6.69331 9.03469C6.58181 8.92306 6.52675 8.7925 6.52813 8.643C6.52963 8.4935 6.58469 8.36056 6.69331 8.24419C6.80969 8.12794 6.94331 8.06788 7.09419 8.064C7.24519 8.06013 7.37887 8.11638 7.49525 8.23275L8.9375 9.675V3.9375C8.9375 3.77788 8.99137 3.64425 9.09912 3.53662C9.20675 3.42887 9.34037 3.375 9.5 3.375C9.65963 3.375 9.79325 3.42887 9.90088 3.53662C10.0086 3.64425 10.0625 3.77788 10.0625 3.9375V9.675L11.5047 8.23275C11.6164 8.12125 11.7488 8.06619 11.9021 8.06756C12.0554 8.06906 12.1903 8.12794 12.3067 8.24419C12.4153 8.36056 12.4716 8.49231 12.4754 8.63944C12.4793 8.78656 12.4231 8.91831 12.3067 9.03469L9.97456 11.3668C9.90431 11.4371 9.83025 11.4866 9.75237 11.5153C9.6745 11.5442 9.59037 11.5586 9.5 11.5586ZM5.23081 14.625C4.85194 14.625 4.53125 14.4938 4.26875 14.2313C4.00625 13.9688 3.875 13.6481 3.875 13.2692V11.7981C3.875 11.6384 3.92887 11.5048 4.03662 11.3972C4.14425 11.2894 4.27788 11.2356 4.4375 11.2356C4.59712 11.2356 4.73075 11.2894 4.83838 11.3972C4.94613 11.5048 5 11.6384 5 11.7981V13.2692C5 13.3269 5.02406 13.3798 5.07219 13.4278C5.12019 13.4759 5.17306 13.5 5.23081 13.5H13.7692C13.8269 13.5 13.8798 13.4759 13.9278 13.4278C13.9759 13.3798 14 13.3269 14 13.2692V11.7981C14 11.6384 14.0539 11.5048 14.1616 11.3972C14.2692 11.2894 14.4029 11.2356 14.5625 11.2356C14.7221 11.2356 14.8558 11.2894 14.9634 11.3972C15.0711 11.5048 15.125 11.6384 15.125 11.7981V13.2692C15.125 13.6481 14.9938 13.9688 14.7313 14.2313C14.4688 14.4938 14.1481 14.625 13.7692 14.625H5.23081Z"
                                fill='#000000'
                            />
                        </g>
                    </svg>
                )}
            </PDFDownloadLink> */}

                {isLoggedIn ? (
                    <button
                        //  onClick={handleDownload}
                        onClick={() => setShowPopup(true)}
                        className="flex flex_direction_col align_items_center"
                        style={{ background: "none", border: "none", cursor: "pointer" }}
                    >
                        <span>
                            <SvgDownload color="#009A50" />
                        </span>
                        <strong
                            style={{ color: "#333", fontWeight: "normal" }}
                            className="Single_pkg_header_modify"
                        >
                            {isDownloading ? (
                                <>
                                    <span>Downloading...</span>
                                </>
                            ) : (
                                'Download'
                            )}
                        </strong>
                    </button>
                ) : (
                    <button
                        onClick={handleDownloadHandler}
                        className="flex flex_direction_col align_items_center"
                        style={{ background: "none", border: "none", cursor: "pointer" }}
                    >
                        <span>
                            <SvgDownload color="#009A50" />
                        </span>
                        <strong
                            style={{ color: "#333", fontWeight: "normal" }}
                            className="Single_pkg_header_modify"
                        >
                            {isDownloading ? (
                                <>
                                    <span>Downloading...</span>
                                </>
                            ) : (
                                'Download'
                            )}
                        </strong>
                    </button>
                )}

                {/* <div style={{ display: 'none' }}>
                    <PDFViewer width={"100%"} height={"1000"} showToolbar={false}>
                        <NewPackageDownloadPdf
                            packageData={packageData}
                            imageData={imageData}
                            logo={logo}
                            userDetails={userDetails}
                            userType={userType}
                            selectedCategory={selectedCategory}
                            allPackageHotels={allPackageHotels}
                            calculatePriceWithMarkup={calculatePriceWithMarkup}
                            selectedOption={selectedOption}
                            additionalMarkup={markupValue}
                            selectedMealPlan={selectedMealPlan}
                        />
                    </PDFViewer>
                </div> */}
            </div>

            {showPopup && (
                <div className="select_hotel_popup_overlay">
                    <div className="select_hotel_popup_overlay_content"
                    // style={{width: '900px', height: '500px', overflow: 'scroll'}}
                    >
                        {/* <button style={{ position: 'absolute', }} onClick={() => setShowPopup(false)}>closee</button> */}
                        {/* <PDFViewer width={"100%"} height={"1000"} showToolbar={false}>
                            <NewPackageDownloadPdf
                                packageData={packageData}
                                imageData={imageData}
                                logo={logo}
                                userDetails={userDetails}
                                userType={userType}
                                selectedCategory={selectedCategory}
                                allPackageHotels={allPackageHotels}
                                calculatePriceWithMarkup={calculatePriceWithMarkup}
                                selectedOption={selectedOption}
                                additionalMarkup={markupValue}
                                selectedMealPlan={selectedMealPlan}
                            />
                        </PDFViewer> */}

                        <h4>Add Additional Markup</h4>
                        <label>
                            <input
                                type="radio"
                                name="newMarkup"
                                value="newMarkup"
                                checked={selectedOption === "newMarkup"}
                                onChange={() => handleOptionChange("newMarkup")}
                            />
                            Add New
                        </label>

                        {selectedOption === "newMarkup" && (
                            <div style={{ marginTop: "10px" }}>
                                <label>
                                    <input
                                        type="number"
                                        className="w-full"
                                        placeholder="Markup %"
                                        value={markupValue}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value < 0) {
                                                setMarkupValue(0);
                                            } else if (value > 100) {
                                                showErrorToast(
                                                    "Please enter a value between 0 and 100"
                                                );
                                                return;
                                            } else {
                                                setMarkupValue(value);
                                            }
                                        }}
                                    />
                                </label>
                            </div>
                        )}

                        <div className="flex flex_gap_10 mt-10">
                            <button
                                disabled={!selectedOption}
                                style={
                                    !selectedOption
                                        ? {
                                            background: "#ccc",
                                        }
                                        : {
                                            background: "#EB442D",
                                        }
                                }
                                onClick={isLoggedIn ? handleDownload : handleDownloadHandler}
                                className="select_hotel_common_btn w-half"
                            >
                                Download
                            </button>
                            <button
                                onClick={() => setShowPopup(false)}
                                className="select_hotel_cancel_btn w-half"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {openGetQuotePopup && (
                <NewGetQuoteDownloadPopup
                    package_id={packageData?.packageId}
                    setshowRatePopup={setOpenGetQuotePopup}
                    handleDownload={handleDownload}
                    packageData={packageData}
                    selectedCategory={selectedCategory}
                />
            )}
        </>
    );
};

export default NewDownloadPdfButton;
